import React from "react";
import { Dialog, DialogActions, DialogContentText, Link } from "@mui/material";
import { Button, DialogContent, DialogTitle } from "../";
import {IInfoBox} from "../../interfaces/info_box";

function LunarNewYear() {
  //설날 팝업
  return (
    <>
      <DialogTitle>{"설 연휴 배차 유의사항"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          안녕하세요. 설 연휴 배차 관련 유의사항 전달드립니다.
          <br />
          <strong>"1/13 ~ 2/9"</strong> 설 연휴로 인한 물동량 증가로 배차가
          지연될 수 있습니다.
          <br />
          원활한 배차를 위해 가능한 한 상차 <strong>24시간 전</strong>에 주문
          부탁드립니다.
        </DialogContentText>
      </DialogContent>
    </>
  );
}

function Chuseok() {
  return (
    <>
      <DialogTitle>{"추석연휴 배차 유의사항"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          안녕하세요. 추석연휴 배차 관련 유의사항 전달드립니다.
          <br />
          <strong>"9/9 ~ 9/27"</strong> 추석 연휴로 인한 물동량 증가로 배차가
          지연될 수 있습니다.
          <br />
          원활한 배차를 위해 가능한 한 상차 <strong>24시간 전</strong>에 주문
          부탁드립니다.
        </DialogContentText>
      </DialogContent>
    </>
  );
}

function UreaSolution() {
  return (
    <>
      <DialogTitle>{"요소수 품귀현상으로 인한 배차 유의사항"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          안녕하세요.
          <br />
          <strong>"요소수 품귀현상"</strong>으로 인해 화물 배차에 차질이
          발생하고 있습니다.
          <br />더 나은 배차를 위해 가능한 한 상차 <strong>24시간 전</strong>에
          주문 부탁드립니다.
          <br />
          배차가 어려운 경우, 유선으로 연락드리겠습니다.
          <br />
          <br />
          관련 뉴스
          <br />
          <Link
            href="https://www.ytn.co.kr/_ln/0102_202111041114048600"
            target="_blank"
          >
            '요소수 대란'에 화물차 장거리 기피..."텅 빈 요소수"
          </Link>
          <br />
          <Link
            href="https://imnews.imbc.com/replay/2021/nwdesk/article/6312064_34936.html"
            target="_blank"
          >
            '요소수 찾아 삼만리‥공장 앞 500미터 줄 선 경유차들"
          </Link>
        </DialogContentText>
      </DialogContent>
    </>
  );
}

function Strike() {
  return (
    <>
      <DialogTitle>
        {"화물연대 무기한 총파업으로 인한 배차 유의사항"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          안녕하세요.
          <br />
          <strong>"화물연대 무기한 총파업"</strong>으로 인해{" "}
          <strong>대형 톤수</strong> 배차에 차질이 발생하고 있습니다.
          <br />
          가능한 빠르게 배차주문을 넣어주시길 부탁드리며, 이슈사항 발생 시 바로
          연락드리도록 하겠습니다.
          <br />
          배차가 어려운 경우, 유선으로 연락드리겠습니다.
          <br />
          <br />
          당사는 사전 차량수배를 통하여 고객님의 물류운영에 문제가 발생하지
          않도록 최선을 다하겠습니다.
          <br />
          <br />
          - 주식회사 카고콜 -
          <br />
          <br />
          <br />
          관련 뉴스
          <br />
          <Link
            href="https://imnews.imbc.com/replay/2022/nwtoday/article/6429551_35752.html"
            target="_blank"
          >
            "안전운임제 3년 연장" 화물연대 "내일 총파업"
          </Link>
          <br />
          <Link
            href="https://www.donga.com/news/Politics/article/all/20221122/116617109/1"
            target="_blank"
          >
            '당정, ‘총파업 예고’ 화물연대에 “이기적 행태, 협상 여지 없다”'
          </Link>
        </DialogContentText>
      </DialogContent>
    </>
  );
}

function StrikeEnd() {
  return (
    <>
      <DialogTitle>{"화물연대 총파업 종료 안내"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          안녕하세요.
          <br />
          화물연대 파업이 <strong>종료</strong>되었으나 8일간 밀렸던
          화물물량으로
          <strong> 약2주간은 차량 배차가 용이하지 않을 수 있습니다.</strong>
          <br />
          배차 시 이슈가 발생하면 바로 유선 연락드리도록 하겠습니다.
          <br />
          당사는 안정적인 차량 수배를 위해 최선을 다하겠습니다.
          <br />
          <br />
          - 주식회사 카고콜 -
          <br />
          <br />
        </DialogContentText>
      </DialogContent>
    </>
  );
}

function Snow() {
  return (
    <>
      <DialogTitle>{"폭설로인한 배차 지연안내"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          안녕하세요.
          <br />
          중부지방을 중심으로 전국적으로 <strong>폭설이 내리고있어</strong>{" "}
          배차에 차질을 겪고 있습니다.
          <br />
          이에따라{" "}
          <strong>
            비나 눈이 예상되는 경우 일찍 주문을 넣어주시면 감사하겠습니다.
          </strong>
          <br />
          또 다른 문제가 발생하면 바로 유선 연락드리도록 하겠습니다.
          <br />
          당사는 안정적인 차량 수배를 위해 최선을 다하겠습니다.
          <br />
          <br />
          - 주식회사 카고콜 -
          <br />
          <br />
        </DialogContentText>
      </DialogContent>
    </>
  );
}

interface IPopup {
  infoBox: IInfoBox;
  close: () => void
}

export default function Popup(props: IPopup) {
  const { infoBox, close } = props;

  return (
    <Dialog
      disableEscapeKeyDown
      maxWidth={"lg"}
      aria-labelledby="confirmation-dialog-title"
      open={infoBox.isOpen}
      onClose={(e: any, reason: string) => {
        if (reason === "backdropClick") return;
        close();
      }}
    >
       {/*<Chuseok />*/}
      {/*<UreaSolution/>*/}
      {/* <Strike /> */}
      {/* <Snow /> */}
      {/* <LunarNewYear />*/}
      <DialogTitle>{infoBox.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" dangerouslySetInnerHTML={{ __html: infoBox.content}} />
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>확인</Button>
      </DialogActions>
    </Dialog>
  );
}
